import React from "react"
import { useTranslation } from "react-i18next"

import { IconSize } from "shared/types/Icon"
import { ProductPosition } from "shared/types/ProductPosition"
import { Room } from "shared/types/Room"
import { ProductPositionAddon } from "shared/types/__generated__/graphql"
import { Button, ButtonVariant } from "shared/ui/buttons/Button"
import { IconName } from "shared/ui/icon/__generated__/IconName"
import { LoadingSpinner } from "shared/ui/loading-spinner/LoadingSpinner"

interface ProductPositionTableRowCollapseButtonProps {
  item: Room | ProductPosition | ProductPositionAddon
  isLoading?: boolean
  isCollapsed: boolean
  onCollapse: React.MouseEventHandler
}

export const ProductPositionTableRowCollapseButton = React.memo(
  ({
    item,
    isLoading,
    isCollapsed,
    onCollapse
  }: ProductPositionTableRowCollapseButtonProps) => {
    const { t } = useTranslation()
    if (isLoading) {
      return <LoadingSpinner small />
    }
    return (
      <Button
        variant={ButtonVariant.TERTIARY}
        id={`${item.id}__collapse-button`}
        isIconOnly
        icon={
          isCollapsed ? IconName.SMALL_CARET_RIGHT : IconName.SMALL_CARET_DOWN
        }
        iconSize={IconSize.XXS}
        onClick={onCollapse}
        tabIndex={-1}
        aria-hidden
        label={isCollapsed ? t("General.Expand") : t("General.Collapse")}
      />
    )
  }
)
